module.exports = __webpack_public_path__ + "static/media/game.0aa0d246.png";